import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FormControl } from '@angular/forms';
import { DataExchangeCommentDto } from 'src/app/data-transfer/entities/data-exchange-request-entities/data-exchange-comment-dto';

@Component({
  selector: 'app-data-exchange-comments',
  templateUrl: './data-exchange-comments.component.html',
  styleUrls: ['./data-exchange-comments.component.scss']
})
export class DataExchangeCommentsComponent {

  @Input() comments: DataExchangeCommentDto[] | null | undefined;
  @Input() canAddComment = true;
  @Output() commentAdded = new EventEmitter<string>();

  readonly commentControl = new FormControl('');

  submit(): void {
    const text = this.commentControl.value?.trim();
    if (!text) { return; }
    this.commentAdded.emit(text);
    this.commentControl.reset('');
  }
}
